import { Accommodation } from "@/components/Accommodation/Accommodation.tsx";
import { RateGroup } from "@/helpers/types/types.ts";
import { NoAccommodationsFound } from "@/pages/AccommodationPicking/components/NoAccommodationsFound/NoAccommodationsFound.tsx";
import { useClientSpecificSorting } from "@/pages/AccommodationPicking/components/RateGroupsList/hooks/useClientSpecificSorting.ts";
import { useTranslation } from "react-i18next";

interface RateGroupsListProps {
  availableRateGroups: RateGroup[];
  isLoading: boolean;
  handleOpenModal: (rateGroup?: RateGroup) => void;
}

export const RateGroupsList = ({ availableRateGroups, isLoading, handleOpenModal }: RateGroupsListProps) => {
  const { t } = useTranslation();
  const { sortRateGroups } = useClientSpecificSorting();

  if (isLoading) return null;
  if (availableRateGroups.length < 1 && !isLoading) {
    return <NoAccommodationsFound />;
  }

  const availableRGs = availableRateGroups.filter((rg) => rg.ratePlans.some((rp) => rp.isAvailable));
  const unavailableRGs = availableRateGroups.filter((rg) => rg.ratePlans.every((rp) => !rp.isAvailable));
  const sortedAvailableRGs = sortRateGroups(availableRGs);

  return (
    <>
      {sortedAvailableRGs?.map((rg, index) => (
        <Accommodation key={rg.id} index={index} rateGroup={rg} handleOpenPreviewModal={handleOpenModal} />
      ))}

      {unavailableRGs.length > 0 && (
        <>
          <h3 className="u-h5 u-fw-600 c-accommodations__list-unavailable-title">
            {t("unavailableInPeriod")}
          </h3>
          {unavailableRGs.map((rg) => (
            <Accommodation key={rg.id} rateGroup={rg} handleOpenPreviewModal={handleOpenModal} />
          ))}
        </>
      )}
    </>
  );
};
